<template>
<span>
  <p><span style="font-size:10pt">Inhalt der Leistung:</span></p>
  <ul>
    <li>
      <p><span style="font-size:10pt">Ausarbeitung einer Erdungsanlage f&uuml;r Blitzschutz</span></p>

      <ul>
        <li>
          <p><span style="font-size:10pt">nach Typ A (Tiefenerder) oder</span></p>
        </li>
        <li>
          <p><span style="font-size:10pt">Typ B (Fundament- und Ringerder)</span></p>
        </li>
      </ul>
    </li>
    <li>
      <p><span style="font-size:10pt">Erstellung von Details</span></p>
    </li>
    <li>
      <p><span style="font-size:10pt">Textliche Beschreibung der Ma&szlig;nahmen</span></p>
    </li>
    <li>
      <p><span style="font-size:10pt">Materialst&uuml;ckliste (LV)</span></p>
    </li>
  </ul>
</span>
</template>

<script>
export default {
  name: "TooltipErdungskonzeptBlitzschutzsysteme"
}
</script>

<style scoped>

</style>
